import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { vehiclesApi, type CreateVehicleInput } from '@/api/vehicles';

export function useMyVehicles() {
  return useQuery({
    queryKey: ['vehicles', 'my'],
    queryFn: () => vehiclesApi.listMy(),
  });
}

export function useCreateVehicle() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateVehicleInput) => vehiclesApi.create(input),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ['vehicles', 'my'] }); },
  });
}

export function useDeleteVehicle() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => vehiclesApi.remove(id),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ['vehicles', 'my'] }); },
  });
}
